import { GdsService_OrderAdditionalServiceGdsServiceVip_Fragment } from '@websky/graphql';
import { State as AllServicesState } from '../../TransferService/model';
import { State } from './types';

export const initialStateFactory = (
	service: GdsService_OrderAdditionalServiceGdsServiceVip_Fragment,
	state: AllServicesState['services']
) => {
	const singleServiceState: State = {};

	for (const [passengerId] of Object.keys(state)) {
		singleServiceState[passengerId] = {};
		for (const [segmentId] of Object.keys(state[passengerId])) {
			singleServiceState[passengerId][segmentId] = state[passengerId][segmentId].find(
				stateService => stateService.service.id === service.id
			);
		}
	}

	return singleServiceState;
};
